import React from "react";

export function PromocionesTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 shadow-lg">
      <p className="text-xs text-slate-400 font-medium">
        {payload[0]?.payload?.date || payload[0]?.payload?.name || ''}
      </p>
      {payload.map((p, i) => (
        <p key={i} className="text-sm font-bold text-white">
          {p.name}: {typeof p.value === "number" ? p.value.toFixed(0) : p.value}
        </p>
      ))}
    </div>
  );
}
